import React from "react";
import { BlueInventoryIcon } from "../../../assets/icons/BlueInventoryIcon";
import { InventoryBarIcon } from "../../../assets/icons/InventorySeachIcon";

interface ServiceItemProps {
  name: string;
  duration: string;
}

export const ServiceItemComponent: React.FC<ServiceItemProps> = ({
  name,
  duration,
}) => (
  <div className="flex flex-col justify">
    <div className="flex px-3">
      <BlueInventoryIcon />
      <span className="text-[14px] font-normal pl-[1em]">{name}</span>
    </div>
    <div className="flex mt-2 px-3 mb-2">
      <InventoryBarIcon />
      <span className="text-[14px] font-normal  pl-[1em]">{duration}</span>
    </div>
  </div>
);
